import 'what-input';

import PropTypes from 'prop-types';
import React from 'react';

import { setLocation } from '$utilities/location';
import { setUserAgent } from '$utilities/user-agent';
import { SkipLink } from '$partials/ui';
import * as Pages from '$pages';
import { GridLines } from '$partials/global';
import { setSiteContext } from '$utilities/site-context';
import { getSidebarTitles, setSidebarTitles } from '$utilities/sidebar-titles';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @component App
 * @props (see propTypes)
 *
 * Renders the application.
 * 1. If the page component requested doesn’t exist, escapes the function.
 * 2. Skip link are useful for keyboard users to access the main content of the page
 *    straight away without the hassle of navigating through the navigation at each page load.
 * 3. Page component (HomePage, UnionPage, etc.).
 */
const App = props => {
    if (props.location) {
        setLocation(props.location);
    }

    if (props.userAgent) {
        setUserAgent(props.userAgent);
    }

    if (props.siteContext) {
        setSiteContext(props.siteContext);
    }

    if (props.data?.sidebarTitles) {
        setSidebarTitles(props.data.sidebarTitles);
    }

    /* [1] */
    if (!props.pageComponent || typeof (Pages[props.pageComponent]) === 'undefined') {
        return null;
    }

    const Component = Pages[props.pageComponent];
    return (
        <>
            {props.dev && (<GridLines />)}
            <SkipLink href='#main-content'>Skip to main content</SkipLink>
            <SkipLink href='#primary-navigation'>Skip to primary navigation</SkipLink>
            <Component {...props} /> {/* [3] */}
        </>
    );
};

/* ========================================================================= */
/* Typing & export(s) */
/* ========================================================================= */

App.propTypes = {
    data: PropTypes.object,
    dev: PropTypes.bool,
    location: PropTypes.string,
    pageComponent: PropTypes.string.isRequired,
    timezone: PropTypes.string,
    userAgent: PropTypes.object.isRequired,
    siteContext: PropTypes.object,
    sidebarTitles: PropTypes.object,
};

export { App };

export default App;
